// Utility to generate a strong random password (throws away after registration)
// Guarantees at least one upper, lower, digit, symbol; default length 32.
export const generateStrongPassword = (requestedLength = 32): string => {
  // Minimum of 4 to satisfy category guarantees
  const length = Math.max(4, requestedLength);
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const symbols = '!@#$%^&*()-_=+[]{}';
  const all = upper + lower + digits + symbols;

  const pick = (set: string): string => {
    // set is never empty for our defined groups
    const idx = Math.floor(Math.random() * set.length);
    return set.charAt(idx);
  };

  const chars: string[] = [
    pick(upper),
    pick(lower),
    pick(digits),
    pick(symbols),
  ];
  const remaining = length - chars.length;

  if (remaining > 0) {
    const buffer = new Uint32Array(remaining);
    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.getRandomValues === 'function'
    ) {
      crypto.getRandomValues(buffer);
    } else {
      for (let i = 0; i < remaining; i++) {
        buffer[i] = Math.floor(Math.random() * all.length);
      }
    }
    for (const v of buffer) {
      const idx = v % all.length;
      chars.push(all.charAt(idx));
    }
  }

  // Fisher-Yates shuffle
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const a = chars[i]!;
    const b = chars[j]!;
    chars[i] = b;
    chars[j] = a;
  }

  return chars.join('');
};
